import DataProvider from '../DataProvider.js'

const validateDispatchTablet = async (values) => {
    const errors = {};
    // eslint-disable-next-line
    const regex = /^\b(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    const validate = async () => {
        const email = values.email.toLowerCase()
        if (regex.test(email)) {
            const tablets = await DataProvider.getList('dispatch-tablets', { pagination: {}, sort: {}, filter: { email: email } })
            if (tablets.data && tablets.data.length > 0) errors.email = [`The email ${email} belongs to an existing tablet`]
        }
    }

    if (values.email && values.validateEmail) (values.email !== values.validateEmail) ? await validate() : console.log(values.email, values.validateEmail)
    else if (values.email) await validate()

    return errors
};


const validateNotifications = (notifications) => {
    const notificationKeys = Object.keys(notifications)
    let validNotifications = false
    for (const key of notificationKeys) {
        if (notifications[key] === true) validNotifications = true
    }
    return validNotifications
}

export {validateNotifications, validateDispatchTablet }
export default validateDispatchTablet